const content = {
    spotify_data_upload: {
        en: {
            data_type_description: 'Spotify Data Upload',
            summary_no_video_html: '<p>This is the second part of the Spotify data task. Please upload your Spotify data file by following the instructions below:</p>',
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>You should have been notified by email that your data download has been sent to you - this will have been an email sent to you within five days after you requested it.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>In order to complete part two, you will need to have saved the data file.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>To save the download file, open the email sent to you by Spotify.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Follow the instructions — e.g. if it asks for your password to access the file.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Download the file to your mobile phone.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>To upload your data, simply tap on <b>Choose file</b> below — find the file that you just saved and then upload it. 
                                          As some files are large, we suggest that you are connecting to wifi to make the upload process as quick as possible.</p>`
                },
                {
                    step_type: 'emoji_step',
                    emoji: '💡',
                    description_html: `<p>PLEASE NOTE WE USE A SECURE UPLOAD SERVICE TO PROTECT YOUR DATA AND YOUR PRIVACY.</p>`
                },
            ]
        }
    }
};

export const spotifyDataTypes = {
    spotify_data_upload: {
        data_type: 'spotify_data_upload',
        data_type_description: 'Spotify Data Upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/spotify.96x96.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.spotify_data_upload,
        }
    },
};